import React from 'react';
import { ProgressSpinner } from 'primereact/progressspinner';

const overlayStyle = { position: 'fixed', inset: 0, zIndex: 9999, background: 'rgba(255,255,255,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center' };

const LoadingOverlay = ({ visible, message }) => {
    if (!visible) return null;

    return (
        <div style={overlayStyle}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1rem' }}>
                <ProgressSpinner style={{ width: 52, height: 52 }} strokeWidth="4" />
                {message && <span style={{ color: '#344054' }}>{message}</span>}
            </div>
        </div>
    );
};

export default LoadingOverlay;
